module.exports = __webpack_public_path__ + "img/403A34_B0936E_7F979C_7E6956-256px.6496cd58.png";